import React from "react";
import { FlowPanel } from "./FlowPanel";

export function FlowView({ items, activeItemId, onItemOpen, onItemClose, onItemMore, onAddToBasket, isItemInBasket }) {
  const flowItems = Array.isArray(items) ? items : [];
  return (
    <div
      className="g-flow -active"
      js-flow="true"
      js-transition-wrapper="true"
    >
      <div className="g-flow__shelf" aria-hidden="true"></div>
      {flowItems.map((item, index) => (
        <FlowPanel
          key={item.id}
          item={item}
          panelIndex={index + 1}
          panelClassName={index === 0 ? "-h" : ""}
          positionClass={item.positionClass}
          isActive={activeItemId === (item.id || item.slug)}
          onOpen={onItemOpen}
          onClose={onItemClose}
          onMore={onItemMore}
          onAddToBasket={onAddToBasket}
          isItemInBasket={isItemInBasket}
        />
      ))}
    </div>
  );
}
